import { useState } from "react";
import { getAvatarPreset } from "../../utils/avatarCatalog";

// Avatar : rendu unifié de la photo de profil, utilisé partout (Navbar, MobileNavbar, ProfilePage).
// Remplit son conteneur parent (w-full h-full) — c'est le parent qui fixe la taille + le rounded.
// Trois cas gérés :
//   1. `value` = un id du catalogue -> pastille colorée + emoji.
//   2. `value` = une ancienne valeur image (base64 `data:` ou URL `http`) -> <img> (rétrocompat).
//   3. sinon (vide ou image en erreur) -> initiales prénom/nom.
export const Avatar = ({
  value,
  firstName = "",
  lastName = "",
  emojiClassName = "text-2xl",
  initialsClassName = "text-xl",
}: {
  value?: string | null;
  firstName?: string;
  lastName?: string;
  emojiClassName?: string;
  initialsClassName?: string;
}) => {
  const [imgError, setImgError] = useState(false);

  const preset = getAvatarPreset(value);
  if (preset) {
    return (
      <div
        className="w-full h-full flex items-center justify-center"
        style={{ backgroundColor: preset.bg }}
      >
        <span className={emojiClassName} role="img" aria-label={preset.label}>
          {preset.emoji}
        </span>
      </div>
    );
  }

  const isImage =
    !!value && (value.startsWith("data:") || value.startsWith("http"));
  if (isImage && !imgError) {
    return (
      <img
        src={value as string}
        alt="Profile"
        className="w-full h-full object-cover"
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div className="w-full h-full flex items-center justify-center bg-tertiary text-secondary-text">
      <span className={`${initialsClassName} font-oxaniumMedium`}>
        {firstName?.[0]}
        {lastName?.[0]}
      </span>
    </div>
  );
};
